import EditPartnerFormContainer from './edit-partner-form-container';

export default EditPartnerFormContainer;
